import { appConfig } from '@/config/appConfig';
import { storageModeManager } from '@/services/storage/storageModeManager';

export interface DesktopEnvironment {
  isDesktop: () => boolean;
  isPWAInstalled: () => boolean;
  promptInstallPWA: () => Promise<void>;
  getDeviceInfo: () => Promise<{ model: string; os: string }>;
  getAppVersion: () => string;
  getStorageCapacity: () => Promise<{ maxStudents: number; currentUsage: string }>;
  isFileSystemModeLocked: () => boolean;
  enableFileSystemMode: () => Promise<boolean>;
}

const isRunningStandalone = (): boolean => {
  return (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator as any)['standalone'] || document.referrer.includes('android-app://');
};

// Export the function that other files are trying to import
export const isDesktopEnvironment = (): boolean => {
  return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const desktopEnvironment = {
  isDesktop: () => {
    return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },

  isPWAInstalled: () => {
    return isRunningStandalone();
  },

  promptInstallPWA: async () => {
    if (typeof window !== 'undefined' && (window as any).deferredPrompt) {
      const prompt = (window as any).deferredPrompt;
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      console.log(`User response to the install prompt: ${outcome}`);
      (window as any).deferredPrompt = null;
    } else {
      console.log('Install prompt not available');
    }
  },

  getDeviceInfo: async () => {
    return {
      model: navigator.userAgent,
      os: navigator.platform
    };
  },

  getAppVersion: () => {
    return appConfig.version;
  },

  async getStorageCapacity(): Promise<{ maxStudents: number; currentUsage: string }> {
    try {
      // Import universalStorage directly to avoid circular dependencies
      const { universalStorage } = await import('../../services/storage/universalStorage');
      const capacityInfo = await universalStorage.estimateStorageCapacity();
      return {
        maxStudents: capacityInfo.maxCapacity,
        currentUsage: capacityInfo.storageUsed
      };
    } catch (error) {
      console.error('Error getting storage capacity:', error);
      return { maxStudents: 0, currentUsage: 'Error' };
    }
  },

  isFileSystemModeLocked: () => {
    return false; // Always false since we only use localStorage
  },

  enableFileSystemMode: async (): Promise<boolean> => {
    return false; // Not available in localStorage-only mode
  },
};
